import loadable from "@loadable/component";
import { ErrorBoundary } from "../../components";
import FullPageLoader from "@Components/FullPageLoader";

const AsyncMediaMentionsV2 = loadable(() => import("./MediaMentionsV2"), {
  fallback: <FullPageLoader />,
});

export default (props: any): JSX.Element => (
  <ErrorBoundary>
    <AsyncMediaMentionsV2 {...props} />
  </ErrorBoundary>
);
